var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchMessengerMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "25px",
    viewBox: "0 0 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSearchMessengerMobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.22783411,19.6727851 C10.4938277,22.9316981 15.733466,23.081275 19.180043,20.0139871 L26.7245046,27.5587916 C26.9189782,27.7525321 27.4969548,28.0296169 28.1253994,27.5587916 C28.753844,27.0879662 28.3191329,26.2169318 28.1253994,26.0224512 L20.5809477,18.4776616 C22.8346483,15.4525573 22.702703,10.1965038 19.3021104,7.12760035 C15.9015178,4.0586969 10.401043,4.0586969 7.1111112,7.47693922 C3.82117938,10.8951816 3.87308096,16.3181413 7.22783411,19.6727851 Z M16.1458199,6.84961532 C18.841714,7.96631928 20.5994859,10.5970896 20.5994859,13.515197 C20.5994859,16.4333045 18.841714,19.0640748 16.1458199,20.1807788 C13.4499258,21.2974827 10.3468224,20.6802035 8.28348812,18.6167786 C6.92496439,17.2667041 6.16103815,15.4305043 6.16103815,13.5151951 C6.16103815,11.5998859 6.92497124,9.76368746 8.28349743,8.41361551 C10.3468224,6.35019061 13.4499258,5.73291136 16.1458199,6.84961532 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger---username",
    transform: "translate(-338.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(15.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(310.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/light-grey-2",
    transform: "translate(0.900726, 0.736461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icSearchMessengerMobile",
    transform: "translate(23.500000, 23.500000) rotate(-32.000000) translate(-23.500000, -23.500000) translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(16.565122, 16.342933) scale(-1, 1) rotate(56.000000) translate(-16.565122, -16.342933) ",
    xlinkHref: "#path-1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchMessengerMobile);
export default __webpack_public_path__ + "static/media/icSearchMessengerMobile.d95401a2333c67c8eb6e8a979cfe63e2.svg";
export { ForwardRef as ReactComponent };